import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";

import Landing from "@/pages/site/Landing";
import Impressum from "@/pages/site/Impressum";
import Datenschutz from "@/pages/site/Datenschutz";

import Stempeluhr from "@/pages/employee/Stempeluhr";
import MeineZeiten from "@/pages/employee/MeineZeiten";
import Urlaub from "@/pages/employee/Urlaub";
import Krankmeldung from "@/pages/employee/Krankmeldung";
import Schichten from "@/pages/employee/Schichten";
import Verfuegbarkeit from "@/pages/employee/Verfuegbarkeit";
import Profil from "@/pages/employee/Profil";
import Lohnabrechnungen from "@/pages/shared/Lohnabrechnungen";

import Dashboard from "@/pages/admin/Dashboard";
import Freigaben from "@/pages/admin/Freigaben";
import Mitarbeiter from "@/pages/admin/Mitarbeiter";
import Schichtplan from "@/pages/admin/Schichtplan";
import Abteilungen from "@/pages/admin/Abteilungen";
import Abwesenheiten from "@/pages/admin/Abwesenheiten";
import Branding from "@/pages/admin/Branding";
import Einstellungen from "@/pages/admin/Einstellungen";
import Nachweise from "@/pages/admin/Nachweise";
import Reports from "@/pages/admin/Reports";
import Orders from "@/pages/orders/Orders";

import Firmen from "@/pages/super/Firmen";
import Kontaktanfragen from "@/pages/super/Kontaktanfragen";
import Kunden from "@/pages/admin/Kunden";
import Margin from "@/pages/admin/Margin";
import Projektstunden from "@/pages/employee/Projektstunden";

// Portal-Subdomain (portal.teamtempus.de) fuehrt direkt ins Portal, sonst Marketing-Landing.
const isPortalHost =
  typeof window !== "undefined" && window.location.hostname.startsWith("portal.");

function RoleHome() {
  const { user } = useAuth();
  if (user?.role === "super_admin") return <Navigate to="/app/firmen" replace />;
  if (user?.role === "admin") return <Navigate to="/app/dashboard" replace />;
  return <Navigate to="/app/stempeluhr" replace />;
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="app-loading">
        Wird geladen…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={isPortalHost ? <Navigate to="/login" replace /> : <Landing />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/app"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<RoleHome />} />
        <Route path="stempeluhr" element={<Stempeluhr />} />
        <Route path="zeiten" element={<MeineZeiten />} />
        <Route path="urlaub" element={<Urlaub />} />
        <Route path="krank" element={<Krankmeldung />} />
        <Route path="schichten" element={<Schichten />} />
        <Route path="verfuegbarkeit" element={<Verfuegbarkeit />} />
        <Route path="auftraege" element={<Orders />} />
        <Route path="nachweise" element={<Nachweise />} />
        <Route path="reports" element={<Reports />} />
        <Route path="kunden" element={<Kunden />} />
        <Route path="margin" element={<Margin />} />
        <Route path="projektstunden" element={<Projektstunden />} />
        <Route path="profil" element={<Profil />} />
        <Route path="lohn" element={<Lohnabrechnungen />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="freigaben" element={<Freigaben />} />
        <Route path="mitarbeiter" element={<Mitarbeiter />} />
        <Route path="schichtplan" element={<Schichtplan />} />
        <Route path="abteilungen" element={<Abteilungen />} />
        <Route path="abwesenheiten" element={<Abwesenheiten />} />
        <Route path="branding" element={<Branding />} />
        <Route path="einstellungen" element={<Einstellungen />} />
        <Route path="firmen" element={<Firmen />} />
        <Route path="kontaktanfragen" element={<Kontaktanfragen />} />
      </Route>
      <Route path="*" element={<Navigate to={isPortalHost ? "/app" : "/"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
